import { render } from "./ExpensesForm.vue?vue&type=template&id=0375506c"
import script from "./ExpensesForm.vue?vue&type=script&lang=js"
export * from "./ExpensesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__